import {
    ModalContent,
    ModalActions,
    Modal,
    Label
} from 'semantic-ui-react'
import ModalHeader from "./ModalHeader";
import Content from "./Content";
import { formatCurrency } from "../../utils/commonutils";
import { generateUniqueABBR } from "../../constants";
import PayDetailDateCell from './PayDetailDateCell';


function payDetailsTableRow(modalDetails, startDate, getPracticeName) {
    let totalCare = 0;
    let totalAdjustment = 0;
    let totalWriteOff = 0;
    let totalBillablecare = 0
    let totalFinNotes = 0
    let totalEarnings = 0;
    let totalCollections = 0;
    let totalHynBcare = 0;
    let totalHynCollections = 0;
    const hygDetails = modalDetails.hygData;
    let payDetails = modalDetails.payDetailsList;

    let hynCollectionsAbbr = [];
    if (modalDetails.contractType === 'Collections w/HYN') {
        const hygArr = generateUniqueABBR(Object.keys(hygDetails));
        hynCollectionsAbbr = hygArr;
        let addingCollectionDays = [];
        modalDetails.sumCollectionsDates.forEach((cdate) => {
            const splitDate = cdate.split("_")[1];
            const filteredPayList = modalDetails.payDetailsList.filter((itemOb) => itemOb.date === splitDate);
            if (filteredPayList.length === 0) {
                let dayCollection = 0;
                const pracName = modalDetails.payDetailsList[0].practice
                modalDetails.sumCollectionsTotalByDate.forEach((objItem) => {
                    dayCollection += objItem[cdate] ? objItem[cdate].Amount : 0;
                })
                addingCollectionDays.push({
                    dayCollectionPrice: dayCollection, date: splitDate, practice: pracName, adjustmentPrice: 0,
                    writeOffPrice: 0, financialNotes: 0, care: 0, billableCare: 0, totalPay: 0
                })
            }
        })

        payDetails = payDetails.concat(addingCollectionDays);
    }

    const isHyg = Object.keys(hygDetails).length > 0
    const periodStart = startDate ? startDate.slice(0, 10) : null;
    const periodEnd = startDate ? new Date(new Date(startDate).getFullYear(), new Date(startDate).getMonth() + 1, 0).toISOString().slice(0, 10) : null;
    const payDetailsRows = payDetails.map((iDetails, idx) => {
        let sumOfHynCollections = 0;
        totalCare += iDetails.care;
        totalAdjustment += iDetails.adjustmentPrice;
        totalBillablecare += iDetails.billableCare;
        totalWriteOff += iDetails.writeOffPrice;
        totalFinNotes += iDetails.financialNotes;
        totalEarnings += iDetails.totalPay;
        totalCollections += iDetails.dayCollectionPrice;
        if (isHyg && modalDetails.contractType !== 'Collections w/HYN') {
            totalHynBcare += (hygDetails[iDetails.date] && (hygDetails[iDetails.date].practiceName === iDetails.practice) ? hygDetails[iDetails.date].billableCare : 0)
        }
        else if (isHyg && modalDetails.contractType === 'Collections w/HYN') {
            hynCollectionsAbbr.forEach((abbr) => {
                const currHygKey = abbr + "_" + iDetails.date;
                sumOfHynCollections += hygDetails[currHygKey] && (hygDetails[currHygKey].practiceName === iDetails.practice) ? hygDetails[currHygKey].Amount : 0;
            });

            totalHynCollections += sumOfHynCollections
        }
        else { totalHynBcare += 0 }

        const isOutOfPeriod = periodStart && periodEnd && (iDetails.date < periodStart || iDetails.date > periodEnd);
        return (
            <tr key={`${idx}-${iDetails.totalPay}`} style={isOutOfPeriod ? { backgroundColor: '#fffde7' } : undefined}>
                <td><PayDetailDateCell row={iDetails} /></td>
                <td>{getPracticeName ? getPracticeName(iDetails.practice) : iDetails.practice}</td>
                <td>{formatCurrency(iDetails.care)}</td>
                <td>{formatCurrency(iDetails.adjustmentPrice)}</td>
                <td>{formatCurrency(iDetails.writeOffPrice * -1)}</td>
                <td>{formatCurrency(modalDetails?.contractType.includes('Collections') ? iDetails.dayCollectionPrice : iDetails.billableCare)}</td>
                {(isHyg && modalDetails.contractType !== 'Collections w/HYN') && <td>{formatCurrency(hygDetails[iDetails.date] && (hygDetails[iDetails.date].practiceName === iDetails.practice) ? hygDetails[iDetails.date].billableCare : 0)}</td>}
                {(isHyg && modalDetails.contractType === 'Collections w/HYN') && <td>{formatCurrency(sumOfHynCollections)}</td>}
                <td>{formatCurrency(iDetails.financialNotes)}</td>
                <td>{formatCurrency(iDetails.totalPay)}</td>
            </tr>
        )
    })

    let totalRows = [<tr key={"payDetailsTotalRow"}>
        <td colSpan={"2"}><b>Total</b></td>
        <td><b>{formatCurrency(totalCare)}</b></td>
        <td><b>{formatCurrency(totalAdjustment)}</b></td>
        <td><b>{formatCurrency(totalWriteOff * -1)}</b></td>
        <td><b>{formatCurrency(modalDetails?.contractType.includes('Collections') ? totalCollections : totalBillablecare)}</b></td>
        {(isHyg && modalDetails.contractType !== 'Collections w/HYN') && <td><b>{formatCurrency(totalHynBcare)}</b></td>}
        {(isHyg && modalDetails.contractType === 'Collections w/HYN') && <td><b>{formatCurrency(totalHynCollections)}</b></td>}
        <td><b>{formatCurrency(totalFinNotes)}</b></td>
        <td><b>{formatCurrency(totalEarnings)}</b></td>
    </tr>]

    return payDetailsRows.concat(totalRows);
}

const collectionGroupByCategory = (objectArray, property, entryStartDate, procStartDate) => {
    return objectArray.reduce(function (acc, obj) {
        let key = obj[property]
        if (!acc[key]) {
            acc[key] = []
        }
        if (obj.EntryDate >= entryStartDate && obj.ProcDate >= procStartDate) {
            acc[key].push(obj)
        }
        return acc
    }, {})
}

function PayCalendarDetailsModal(props) {
    const {
        open, toggleCalendarModal, type, modalDetails, onSelectEvent, detailsModal,
        providerData, startDate, earnings, basePay, productionPrice, eventDate, contractType,
        getPracticeName, doctorName, sendEarningsReportButton, sendReport, sendGoxReport,
        mtdBillable, sendCollectionsReport, currentPeriod, sendHygienistBillableCareReport
    } = props;

    const payDetailsRows = payDetailsTableRow(modalDetails, startDate, getPracticeName);
    const detailsModalType = (type === 'billableCare' || type === 'HYNbillableCare') ? 'production' : (type === 'goxBillableCare' ? 'goxDetailsList' : type);

    const handleSendCollectionsReport = (contractType, doctorName, detailsModal, CollectionList, collectionsEntryStartDate, collectionsProcedureStartDate) => {
        if (detailsModal !== 'details') {
            CollectionList = collectionGroupByCategory(CollectionList, 'Category', collectionsEntryStartDate, collectionsProcedureStartDate);
        }
        sendCollectionsReport(contractType, doctorName, detailsModal, CollectionList, collectionsEntryStartDate, collectionsProcedureStartDate)
    }

    return (
        <Modal
            closeIcon
            open={open}
            onClose={() => toggleCalendarModal(false)}
            style={{ overflow: 'auto' }}
            size={"large"}
        >
            <ModalHeader
                modalType={type}
                modalContractType={modalDetails.contractType}
                startDate={startDate}
                doctorName={doctorName}
                providerCustomRates={modalDetails.providerCustomRates}
                modalWithHyn={modalDetails.contractType.includes('w/HYN')}
            />
            <ModalContent className='pt-0 scrolling'>
                {modalDetails.contractType === 'Sum Of' && providerData.doctorPayVariables.tedCollections && (<Label
                    as='div'
                    className={'cursorPointer borderPrimary'}
                    ribbon='right'
                    style={{ backgroundColor: '#32CD32', filter: 'brightness(120%)', color: '#000000' }} >
                    TED
                </Label>)}
                <Content
                    details={modalDetails}
                    type={type}
                    onSelectEvent={onSelectEvent}
                    detailsModal={detailsModal}
                    providerData={providerData}
                    startDate={startDate}
                    earnings={earnings}
                    basePay={basePay}
                    formatCurrency={formatCurrency}
                    getPracticeName={getPracticeName}
                    payDetails={payDetailsRows}
                    collectionGroupByCategory={collectionGroupByCategory}
                    currentPeriod={currentPeriod}
                />
            </ModalContent>
            <ModalActions style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end' }}>
                <button className="cdp-filter-toggle" onClick={() => toggleCalendarModal(false)}>
                    <i className="remove icon" /> Cancel
                </button>
                {type !== 'earnings' && (type === 'billableCare' || type === 'HYNbillableCare') ? <button className="cdp-filter-toggle cdp-filter-toggle--active" onClick={() => (type === 'HYNbillableCare') ? sendHygienistBillableCareReport() : sendReport(detailsModalType, detailsModal, 'month', mtdBillable, productionPrice, eventDate, startDate)
                }>
                    <i className="send icon" /> Send
                </button> : ''}
                {type !== 'earnings' && type === 'goxBillableCare' ? <button className="cdp-filter-toggle cdp-filter-toggle--active" onClick={() => sendGoxReport(contractType, doctorName, modalDetails.goxList, modalDetails.billableCareData)}>
                    <i className="send icon" /> Send
                </button> : ''}
                {(type === 'collectionList' || type === 'collectionsBillableCare' || type === 'tedCollections') && <button className="cdp-filter-toggle cdp-filter-toggle--active" onClick={() => handleSendCollectionsReport(contractType, doctorName, detailsModal, type === 'tedCollections' ? (modalDetails?.collectionsList ?? []).filter(c => c.isTedDay) : modalDetails?.collectionsList, modalDetails?.collectionsEntryStartDate, modalDetails?.collectionsProcedureStartDate)}>
                    <i className="send icon" /> Send
                </button>}
                {(type === 'collectionsHynList') && <button className="cdp-filter-toggle cdp-filter-toggle--active" onClick={() => handleSendCollectionsReport(contractType, doctorName, detailsModal, modalDetails?.hygCollectionList, modalDetails?.collectionsEntryStartDate, modalDetails?.collectionsProcedureStartDate)}>
                    <i className="send icon" /> Send
                </button>}
                {type === 'earnings' && sendEarningsReportButton}
            </ModalActions>
        </Modal>
    )
}

export default PayCalendarDetailsModal
